module.exports = __webpack_public_path__ + "media/images/HowItWorksLeft-26090a49d7f6c6fc21325d2c88442157.svg";